import { isNative } from './platform';

const DEFAULT_NATIVE_RETURN_URL = 'com.westprop.residentsportal://payments/return';

export const getPaymentReturnUrl = (propertyId?: string): string => {
  if (typeof window === 'undefined') {
    return DEFAULT_NATIVE_RETURN_URL;
  }

  if (isNative()) {
    return import.meta.env.VITE_NATIVE_RETURN_URL || DEFAULT_NATIVE_RETURN_URL;
  }

  return propertyId
    ? `${window.location.origin}/property/${propertyId}`
    : `${window.location.origin}/payments/return`;
};